import { render, staticRenderFns } from "./earlyAccess.vue?vue&type=template&id=011aa2f5&scoped=true"
import script from "./earlyAccess.vue?vue&type=script&lang=js"
export * from "./earlyAccess.vue?vue&type=script&lang=js"
import style0 from "./earlyAccess.vue?vue&type=style&index=0&id=011aa2f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011aa2f5",
  null
  
)

export default component.exports